// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Um0b","header":"ClearentDisclaimer_header__3EbpI","inner":"ClearentDisclaimer_inner__banxv"};